import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import './Navbar.css';

function Navbar({ cartCount }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  return (
    <nav className="luxury-navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <div className="logo-content">
            <span className="logo-crescent">☪</span>
            <div className="logo-text">
              <span className="logo-main">BAYT AL-KHAYR</span>
              <span className="logo-sub">EST. 2026 • MEDINA</span>
            </div>
          </div>
        </Link>

        <button 
          className="menu-toggle"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>

        <ul className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
          <li>
            <Link 
              to="/" 
              className={location.pathname === '/' ? 'active' : ''}
              onClick={() => setIsMenuOpen(false)}
            >
              HOME
            </Link>
          </li>
          <li>
            <Link 
              to="/collection" 
              className={location.pathname === '/collection' ? 'active' : ''}
              onClick={() => setIsMenuOpen(false)}
            >
              COLLECTION
            </Link>
          </li>
          <li>
            <Link 
              to="/about" 
              className={location.pathname === '/about' ? 'active' : ''}
              onClick={() => setIsMenuOpen(false)}
            >
              ABOUT
            </Link>
          </li>
          <li>
            <Link 
              to="/contact" 
              className={location.pathname === '/contact' ? 'active' : ''}
              onClick={() => setIsMenuOpen(false)}
            >
              CONTACT
            </Link>
          </li>
        </ul>

        <div className="navbar-actions">
          <Link to="/cart" className="cart-link">
            <span>CART</span>
            <span className="cart-count-badge">({cartCount})</span>
          </Link>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
